import { Column, TableCell } from '@/components/Table';
import { AgePlaysResponse, AgeData, SelectedPlatform } from '@/types/api/age';
import { PlatformSelectionTable } from '@/routes/AudiencePage/charts/PlatformSelectionTable';
import { sortByPlatformDisplayOrder } from '@/utils/platformUtils';

export const AgeDataByPlatform = ({
  data,
  selectedPlatform,
  handlePlatformChange,
}: {
  data: AgePlaysResponse;
  selectedPlatform: SelectedPlatform<typeof data>;
  handlePlatformChange: (platform: SelectedPlatform<typeof data>) => void;
}) => {
  const getHighestValueLabel = (data: AgeData[]) => {
    const highestValueObject = [...data].sort((a, b) => b.value - a.value)[0];
    return (
      <>
        <span className="text-textDarkGrey font-normal">{highestValueObject.label}</span>{' '}
        <span className="text-textMedGrey font-light text-sm ml-1">
          {Math.round(highestValueObject.percentage)}%
        </span>
      </>
    );
  };

  const tableColumns: Column[] = [
    { key: 'radio', header: '', align: 'left' },
    { key: 'platform', header: 'Platform', className: 'p-2' },
    { key: 'top_age_group', header: 'Top age group', align: 'left', className: 'p-2' },
    { key: 'median_age', header: 'Median age', align: 'right', className: 'p-2' },
  ];

  return (
    <div className="max-w-full">
      <PlatformSelectionTable<AgePlaysResponse, AgePlaysResponse['plays'][number]>
        idPrefix="age-data"
        data={sortByPlatformDisplayOrder(data)}
        selectedPlatform={selectedPlatform}
        handlePlatformChange={handlePlatformChange}
        tableColumns={tableColumns}
        renderDataCells={(rowData: AgePlaysResponse['plays'][number]) => (
          <>
            <TableCell align="left" className="px-2">
              {getHighestValueLabel(rowData.age_distribution)}
            </TableCell>
            <TableCell align="right" className="px-2">
              {rowData.median_age}
            </TableCell>
          </>
        )}
      />
    </div>
  );
};
